import PublicLayout from '../../components/layouts/PublicLayout';
import {CategorySlug, AgencyById, PublicTechnology} from '../../lib/Endpoints.jsx';
import Image from 'next/image';
import { Container, FormGroup, Input,Form, Button, UncontrolledCollapse, List, ListInlineItem
} from 'reactstrap';
import React, { useState, useEffect, useContext } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router'
import axios from 'axios';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import QuoteListing from '../../components/public/Quote/CreateModal';
import ProfileImage from '../../public/public/preview-image.jpg'
import Head from 'next/head';
const hourlyRate = [
	{ id: 1, name: "Any hourly rate", value: '' },
	{ id: 2, name: '$10 and below', value: '10' },
	{ id: 3, name: '$10 - $30', value: [10,30]},
	{ id: 4, name: '$30 - $60', value: [30, 60] },
	{ id: 5, name: '$60 & above', value: '60' }
]

function Page({response, meta, data}) {

	const router = useRouter();
	const [categoryId, setCategory] = useState("");
	const [subCategoryId, setSubCategory] = useState("");
	const [loading, setLoading] = useState(false);
	const [pageCount, setPaginationCount] = useState(1);
	const [agencies, setAgencyData] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [location, setLocation] = useState('');
	const [sortName, setSortName] = useState('Select ');
	const [sortOrder, setSortOrder] = useState('');
	const [hourlyRateId, setHourlyRateId] = useState('');
	const [navExpended, setNavExpanded] = useState(false);
	const [hourlyStartDate, setHourlyStartDate] = useState('');
	const [hourlyEndDate, setHourlyEndDate] = useState('');
	const [showServiceFilter, setShowServiceFilter] = useState(true);
	const [subCategories, setSubCategories] = useState(true);
	const [visible, setVisible] = useState(10);
	const [sortDisplayName, setSortDisplayName] = useState('Select');
    // const [meta, setMeta] = useState('');


	const loadMore = () => {
		 setVisible(visible + 5);
	}
	const loadLess = () => {
		setVisible(10);
	}

	const onChangeNavExpanded = (expanded) =>  {
		setNavExpanded(expanded);
	}

	const onChangeLocation = (e) => {
		setTimeout(() => {
			setLocation(e.target.value);
			// getAgenciesById(categoryId);
		}, 500);
	}

	const onChangeSortBy = (e, value) => {
		setTimeout(() => {
			setSortName(value)
			let name = 'Name';
			if(value === 'rating_average') {
				name = 'Rating Average';
			}
				setSortDisplayName(name)
			// getAgenciesById(categoryId);
		}, 500);
	}
	
	const onChangeSortOrder = (e, value) => {
		setTimeout(() => {
			setSortOrder(value);
			// getAgenciesById(categoryId);
		}, 500);
	}

	const onSubmit = (e) => {

	}

	const onChangeHourlyRate = (e) => {
		let startRate = null;
		let endRate = null;
		let hourlyRateId = null;
		if(e.target.checked) {
			hourlyRateId = e.target.getAttribute('data-id');
			const hourlyRate = e.target.value.split(',');
			switch(e.target.id) {
				case '$10 - $30':
				case '$30 - $60':
				startRate = hourlyRate[0];
				endRate = hourlyRate[1];
				break;
				case '$10 and below':
				startRate = null;
				endRate = hourlyRate[0];
				break;
				case '$60 & above':
				startRate = hourlyRate[0];
				endRate = null;
				break;
				default:
				break;
			}
		}

		setHourlyStartDate(startRate);
		setHourlyEndDate(endRate);
		setHourlyRateId(hourlyRateId);
		getHourlyRateList();
		// getAgenciesById(categoryId);
	}

	const onChangeServiceId = (e) => {
		if(!e.target.checked) {
			setSubCategory("");
		}else if(e.target.checked) {
			setSubCategory(e.target.value);
		}
		// setTimeout(() => {
		// 	getAgenciesById(categoryId);
		// }, 500);
	}

	const getHourlyRateList = () => {
		return hourlyRate.map((data, index) => {
			var inputProps = {
				value: data.value,
			};
			
			if (data.id === parseInt(hourlyRateId)){
				inputProps.checked = true;
			}
			return (
				<>
					<li>
						<FormGroup>
							<input type="checkbox" id={data.name} className="checkbox__field_c" name='budget' data-id={data.id} onClick={onChangeHourlyRate} {...inputProps}/>
							<label htmlFor={data.name}>{data.name}</label>
						</FormGroup>
					</li>
				</>
				)
		});
	}

	const servicesList = () => {
		if(subCategories.length) {
			return subCategories.slice(0, visible).map((data, index) => {
				var inputProps = {
					value: data.id,
				};

				if (data.id === categoryId){
					// inputProps.checked = !this.state.isChecked;
				}
				return (
					<li key={index}>
						<FormGroup>
							<input type="checkbox" id={data.id + 'service_filter'} onClick={(e) => onChangeServiceId(e, data.attributes.slug)} {...inputProps}></input>
							<label htmlFor={data.id + 'service_filter'}>{data.attributes.name}</label>
						</FormGroup>
					</li>
				)
			});
		}
	}

	const onClickServiceFilter = () => {
		setShowServiceFilter(false);
	}

	const getSubCategoriesList = () => {
		axios.get(PublicTechnology, {
			headers: { "Accept": "application/json" }

		}).then((response) => {
			setSubCategories(response.data.data)

		},(error) => {
		});
	}

	const getAgenciesById = (categoryId) => {
		setLoading(true);
		setAgencyData([]);
		axios.get(AgencyById, {
			params: {
				hourly_start_rate: hourlyStartDate,
				hourly_end_rate: hourlyEndDate,
				location: location,
				category_id: categoryId,
				sort_by: sortName,
				sort_order: sortOrder,
				sub_category_id: subCategoryId,
				page: currentPage,
				limit: 15,
				// category_slug: this.state.category_slug ? this.state.category_slug : this.props.match.params.category
			},
			headers: { "Accept": "application/json" }

		}).then((response) => {
			let pagination = response.data.meta.pagination;
			setAgencyData(response.data.data);
			setLoading(false);

			if(pagination) {
				setPaginationCount(pagination.total_pages);
			}

		},(error) => {
			setLoading(false);

			// this.setState({loader:false});
		});
	}

	useEffect(() => {

		setAgencyData([]);
		if(data) { 
			setAgencyData(data.data);
			let pagination = data.meta.pagination;
			if(pagination) {
				setPaginationCount(pagination.total_pages);
			}
		}
		getSubCategoriesList();
	}, []);
	
	useEffect(() => {
		if(!response) {
			router.push('/404');
		}

		setCategory(response.id)
		getAgenciesById(response.id);
		getSubCategoriesList();

	}, [response, meta, hourlyStartDate,hourlyEndDate,location,categoryId,sortName,sortOrder,
	subCategoryId,currentPage]);

	const onClickReviewBtn = (slug) =>{
		router.push({pathname:"/write-review/"+ slug});
	}

	const flashHandler = () =>{
	}

	const resetForm = () => {
	}
	const errorHandler = () => {
	}

	const totalRating = (attribute) => {
		let data = [];
		let index = 5;

		if(attribute.total_rating === 0) {
			index = 4;
		}
		for(let i=1; i<=attribute.total_rating; i++) {
			let rating = <li><i className="fas fa-star"></i></li>;
			data.push(rating);
		}

		for(let i=index; i>=attribute.total_rating; i--) {
			let blankRating = <li><i className="far fa-star"></i></li>;
			data.push(blankRating);
		}

		return data;
	}

	const getCategoriesListing = (attribute) =>
	{
		if(attribute.categories_and_tasks.length) {
			return attribute.categories_and_tasks.map((data, index) => {
				let showComma = '';
				if(attribute.categories_and_tasks.length > index+1) {
					showComma = ",";

				}
				return <span key={index} className="agency_category">{data.name}{showComma}&nbsp;</span>

			});
		}

		return <></>
	}

	const quoteParam = (agency) => {
		return {
			postalCode: agency.postal_code,
			service: agency.category_ids,
		}
	}

	const tagList = (tags) => {
		if(tags.length) {
			return tags.map((data, i) => {
				return (
					<ListInlineItem key={i}>{data.name}</ListInlineItem>
				);
			})

		} else {
			return (<></>);
		}
	}

	 const setPageNumber = (pageNumber) => {
		setTimeout(() => {
			setCurrentPage(pageNumber.selected+1);
			// getAgenciesById(categoryId, pageNumber.selected+1);
		}, 200)
	}

	const DataTable = () => {
		if(agencies.length) {
			return agencies.map((res, i) => {
				let agency = res.attributes;
				return (<div key={i} className="agency-list-detail_wrapper">

				<div className="upper-section">
				<div className='p_img_wrap reset_img'>
				<Image src={agency.website_logo ? agency.website_logo : ProfileImage} alt="Agency" layout='fill' />
				</div>
				<div className="content-wrap">
				<a className="" href={"/agency-detail/" + agency.slug + '/'} style={{'textDecoration': 'none'}}>
					<p className="agency-name">{agency.name}</p>
				</a>
			{/*<span>Browse categories</span>*/}
			<List type="inline" className="rating-list" key="">
			{

			}
			<ListInlineItem>{agency.total_rating_average}%</ListInlineItem>
			<ListInlineItem>
			<ul className="star-rating">
			{totalRating(agency)}
			</ul>
			</ListInlineItem>
			<ListInlineItem>
			{ agency.reviews_counts ? 
				<Link className="" href={"/agency-detail/" + agency.slug} style={{'textDecoration': 'none'}}>
				<p className="reviews" style={{'color': 'black'}}>{agency.reviews_counts} Reviews</p>
				</Link> : <p className="reviews" style={{'color': 'black'}}>{agency.reviews_counts} Reviews</p>
			}
			</ListInlineItem>
			</List>
			{getCategoriesListing(agency)}
			<p className="description-text-sm">
			{agency.description && agency.description.substr(0, 200)} {agency.description && agency.description.length > 200 ? '...' : ''}
			</p>
			</div>
			<div className="btn_block_right">
			<div className="review_block">
				<QuoteListing 
					state={quoteParam(res.attributes)} 
					agencyId={agency.id} 
					handler={errorHandler}
					flashHandler={flashHandler}
					resetForm={resetForm}
				/>
			</div>
				<a className='second-btn' style={{'cursor': 'pointer'}} onClick={(e) => (onClickReviewBtn(agency.slug))}><span>write a review</span></a>
			</div>
			</div>
			{agency.tags.length ? 
				<div className="bottom-section">
				<div className="tags-wrap">
				<span className="tag-text">Tags:</span>
				<List type="inline" className="tag-listing" key="">
				{tagList(agency.tags)}
				</List>
				</div>
				</div> : ''
			}

			</div>)
			});
		}else if(!loading) {
			return <p style={{'textAlign': 'center'}}>No Record Found!</p>
		}
	}

	if (router.isFallback) {
		return (<div className="agency_listing_filter">
			<Container fluid="xl"><div id="spinner" className="spinner_req_review" style={{"display":  "block"}}>
				<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
			</div></Container></div> )
  	}

  	const checked = (<i className="fa fa-check checkBoxSort" aria-hidden="true"></i>)
    if(response ) {
    	const category = response;
    	const categoryAttr = response.attributes;
    	const categoryId = category.id;
		return (
			<>
			<Head>
	            <meta name="keywords" content={meta ? meta.keywords : ''} />
	            <title>{meta ? meta.title : ''}</title>
	            <meta name="description" content={meta ? meta.description : ''} />
	            <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + '/agencies/' +category.attributes.slug + '/'} />
	        </Head>
			<div className="agency_listing_filter">
			<Container fluid="xl">
				<div className="agency_top_description">
					<p className="breadcrumb_text">Home &gt; 
						{
							category && category.attributes ?
							<span>{' ' +category.attributes.name}</span>
							: ''
						}
					</p>
					{meta && meta.heading && (meta.heading !== 'null') ? <><h1>{meta.heading} </h1><br/></> : ''}
					<p className="description-text-sm">{category && category.attributes ? category.attributes.description : ''}</p>
				</div>
			</Container>
			<div className="listing_section_agency">
				 <Container fluid="xl">
					<div className="inner_block_wrapper">
						<div className="location_sort_filter">
							<div className="filter_section">
								<Form className="containers" onSubmit={ e => {
										e.preventDefault(); }}>
									<FormGroup className="loc_filter_wrap">
										<Input
											type="text"
											name="location"
											placeholder='&#xf3c5; Location'
											className="input_text"
											// defaultValue={location ? location : ''}
											onChange={onChangeLocation}/>                            
										{/*{location ? 
											<i className="fal fa-times" onClick={setLocation('')} ></i> 
											: ''
										}*/}
										<Button type="submit" className="primary-btn" onClick={onSubmit()}>
											<span>Search</span>
										</Button>
									</FormGroup>
								</Form>
							</div>
							<div className="right__agency_section filter_sort_wrap">
								<h5>Sort By:</h5>
								<Dropdown>
									<Dropdown.Toggle id="dropdown-custom-components">
										{sortName ? sortDisplayName : 'Select'}
									</Dropdown.Toggle>
									<Dropdown.Menu >
										<Dropdown.Item eventKey="2" onClick={(e) => onChangeSortBy(e, 'name')}>
											Name{ sortName == 'name' ? checked : null }
										</Dropdown.Item>
										<Dropdown.Item eventKey="2" onClick={(e) => onChangeSortBy(e, 'rating_average')}>
											Rating Average{ sortName == 'rating_average' ? checked : null }
										</Dropdown.Item>
										<Dropdown.Divider />
										<Dropdown.Header>Sort Order</Dropdown.Header>
										<Dropdown.Item eventKey="1" onClick={(e) => onChangeSortOrder(e, 'asc')}>
											Ascending { sortOrder == 'asc' ? checked : null }
										</Dropdown.Item>
										<Dropdown.Item eventKey="2" onClick={(e) => onChangeSortOrder(e, 'desc')}>
											Descending{ sortOrder == 'desc' ? checked : null }
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
						<div className="filter_section">
							<Navbar collapseOnSelect expand="lg" className="filter_navbar" onToggle={onChangeNavExpanded} expanded={navExpended}>
								<Navbar.Toggle aria-controls="responsive-navbar-nav" />
								<Navbar.Collapse id="responsive-navbar-nav"> 
									<Navbar.Toggle aria-controls="responsive-navbar-nav" className="close-btn"/>
										<h3 className="filter_heading">Filter by:</h3>
										<Nav className="option-inner-wrap">
											<li>
												<span className="filter__options" id="toggler" onClick={onClickServiceFilter}>
													Sub Categories
												</span>
												<UncontrolledCollapse toggler="#toggler" className={ showServiceFilter ? 'filter_opt_list show' : 'filter_opt_list'}>
													<List type="unstyled" key="0">
														{servicesList()}
													</List>
													{visible < subCategories.length &&
											            <button onClick={loadMore} type="button" className="load-more">Load more</button>
											        }
													{visible > subCategories.length ?  <button onClick={loadLess} type="button" className="load-more">Load Less</button> : ''}
												</UncontrolledCollapse>
											</li> 
											<li>
												<span className="filter__options" id="budget">
													Hourly Rate
												</span>
												<UncontrolledCollapse toggler="#budget" className="filter_opt_list" >
													<List type="unstyled" key="1">
														{getHourlyRateList()}
													</List>
												</UncontrolledCollapse>
											</li>
										</Nav>
								</Navbar.Collapse>
							</Navbar>
						</div>
						<div className="right__agency_section right__agency_loader">
						<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
							<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
						</div> 
							{DataTable()} 
						  <div className="custom-pagination-fr" style={{'display': pageCount > 1 ? '' : 'none'}}>
							<ReactPaginate
									breakLabel="..."
									nextLabel=">"
									marginPagesDisplayed={1}
									pageRangeDisplayed={1}
									pageCount={pageCount}
									previousLabel="<"
									nextLinkClassName="next"
									previousLinkClassName="prev"
									activePage={currentPage}
									forcePage={currentPage-1}
									onPageChange={(pageNumber) => setPageNumber(pageNumber)}
									renderOnZeroPageCount={1}
								/>
						</div>
						</div>
						
					</div>	
				</Container>
			</div>		
		</div>
		 </>
		)
    }

}

// This gets called on every request
export async function getServerSideProps(context) {
    try {
        const res = await axios.get(process.env.NEXT_PUBLIC_API_URL+'category/'+context.query.slug, { headers: {
            "Accept": "application/json" }
        });

        const resMeta = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/agencies/' + context.query.slug, { headers: {
            "Accept": "application/json" }
        });

        if(res.data.data) {
			const agenciesRes =  await axios.get(process.env.NEXT_PUBLIC_API_URL + 'search/agencies', {
				params: {
					category_id: res.data.data.id,
					limit: 15,
				},
				headers: { "Accept": "application/json" }
			});

			return { props: { response: res.data.data, meta: resMeta.data.data, data: agenciesRes.data } }

        }
        return { props: { response: res.data.data, meta: resMeta.data.data, data: false } }

    } catch (err) {
    
        const response = false;
        const meta = false;
        const data = false;

        return { props: { response, meta, data } };
    }
}


Page.Layout = PublicLayout;

export default Page;
